"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCookieToObject = exports.endResponseSafely = exports.readRequestHeader = exports.readSessionId = exports.readSessionIdFromCookie = exports.readAuthInput = exports.HTTPHeaders = void 0;
const models_1 = require("../../models");
const server_1 = require("../server");
var HTTPHeaders;
(function (HTTPHeaders) {
    HTTPHeaders["Accept"] = "accept";
    HTTPHeaders["AcceptLanguage"] = "accept-language";
    HTTPHeaders["ContentType"] = "content-type";
    HTTPHeaders["Cookie"] = "cookie";
    HTTPHeaders["Date"] = "date";
    HTTPHeaders["Forwarded"] = "forwarded";
    HTTPHeaders["Host"] = "host";
    HTTPHeaders["Location"] = "location";
    HTTPHeaders["Origin"] = "origin";
    HTTPHeaders["Referer"] = "referer";
    HTTPHeaders["UserAgent"] = "user-agent";
    HTTPHeaders["XForwardedFor"] = "x-forwarded-for";
    HTTPHeaders["XForwardedHost"] = "x-forwarded-host";
    HTTPHeaders["XForwardedProto"] = "x-forwarded-proto";
    HTTPHeaders["XCsrfToken"] = "x-csrf-token";
    HTTPHeaders["XOriginalUri"] = "x-original-uri";
    HTTPHeaders["ref"] = "ref-override";
    HTTPHeaders["RequestId"] = "X-Amzn-RequestId";
    HTTPHeaders["Adgwdg"] = "adgwdg";
    HTTPHeaders["MoneraTemplateType"] = "monera-template-type";
    HTTPHeaders["MoneraAppQuery"] = "monera-app-query";
    HTTPHeaders["OriginalRequestId"] = "monera-original-req-id";
    HTTPHeaders["MoneraAppOriginalUri"] = "monera-app-original-uri";
    HTTPHeaders["I18nPreferences"] = "i18n-preferences";
    HTTPHeaders["DeviceAttributes"] = "device-attr";
})(HTTPHeaders = exports.HTTPHeaders || (exports.HTTPHeaders = {}));
const readAuthInput = (req) => {
    var _a, _b, _c;
    const authTokenFromHeader = (0, exports.readRequestHeader)(req, models_1.ShoppingPortalHeadersEnum.AuthToken);
    if (authTokenFromHeader) {
        return {
            browserId: (0, exports.readRequestHeader)(req, models_1.ShoppingPortalHeadersEnum.UBID),
            token: authTokenFromHeader
        };
    }
    const cookies = (0, exports.parseCookieToObject)(((_a = req === null || req === void 0 ? void 0 : req.headers) === null || _a === void 0 ? void 0 : _a.cookie) || '');
    return {
        browserId: (_b = cookies['ubid-tacbus']) !== null && _b !== void 0 ? _b : '',
        token: (_c = cookies['at-tacbus']) !== null && _c !== void 0 ? _c : ''
    };
};
exports.readAuthInput = readAuthInput;
const readSessionIdFromCookie = (req) => {
    var _a, _b;
    const cookies = (0, exports.parseCookieToObject)(((_a = req === null || req === void 0 ? void 0 : req.headers) === null || _a === void 0 ? void 0 : _a.cookie) || '');
    return (_b = cookies['session-id']) !== null && _b !== void 0 ? _b : '';
};
exports.readSessionIdFromCookie = readSessionIdFromCookie;
const readSessionId = (req) => (0, exports.readRequestHeader)(req, models_1.ShoppingPortalHeadersEnum.SessionIdAuthToken) || '';
exports.readSessionId = readSessionId;
const readRequestHeader = (req, headerName, defaultValue = '') => (req && req.headers && req.headers[headerName]) || defaultValue;
exports.readRequestHeader = readRequestHeader;
const endResponseSafely = (res, chunk, callback) => {
    res.end(chunk, callback);
    res.setHeader = (name, value) => server_1.serverConsole.warn(`setHeader with ${name}=${value} was called after response end`);
};
exports.endResponseSafely = endResponseSafely;
const decode = decodeURIComponent;
const pairSplitRegExp = /; */;
const parseCookieToObject = (str) => {
    if (typeof str !== 'string') {
        throw new TypeError('argument str must be a string');
    }
    const obj = {};
    const pairs = str.split(pairSplitRegExp);
    for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i];
        let eqIdx = pair.indexOf('=');
        if (eqIdx < 0) {
            continue;
        }
        const key = pair.substr(0, eqIdx).trim();
        let val = pair.substr(++eqIdx, pair.length).trim();
        if ('"' == val[0]) {
            val = val.slice(1, -1);
        }
        if (undefined == obj[key]) {
            obj[key] = tryDecode(val);
        }
    }
    return obj;
};
exports.parseCookieToObject = parseCookieToObject;
const tryDecode = (str) => {
    try {
        return decode(str);
    }
    catch (e) {
        return str;
    }
};
